/**
 * Language Types for Voice Simulation
 *
 * @deprecated This is for old ElevenLabs/VAPI voice system.
 * New personas use Google Chirp language codes (BCP-47 format).
 * @see CovalVoiceConstants.ts for new language system
 */

export const LANGUAGE_TYPES = [
  { id: "multi", name: "Multilingual (Auto-Detect)", flag: "🌐" },
  { id: "en", name: "English", flag: "🇺🇸" },
  { id: "es", name: "Spanish", flag: "🇪🇸" },
  { id: "fr", name: "French", flag: "🇫🇷" },
  { id: "fr-CA", name: "French Canadian", flag: "🇨🇦" },
  { id: "de", name: "German", flag: "🇩🇪" },
  { id: "hr", name: "Croatian", flag: "🇭🇷" },
  { id: "it", name: "Italian", flag: "🇮🇹" },
  { id: "tr", name: "Turkish", flag: "🇹🇷" },
  { id: "ar", name: "Arabic", flag: "🇦🇪" },
  { id: "hi", name: "Hindi", flag: "🇮🇳" },
  { id: "nl", name: "Dutch", flag: "🇳🇱" },
  { id: "pt-BR", name: "Brazilian Portuguese", flag: "🇧🇷" },
  { id: "pt", name: "Portuguese", flag: "🇵🇹" },
  { id: "ja", name: "Japanese", flag: "🇯🇵" },
  { id: "zh", name: "Chinese", flag: "🇨🇳" },
  { id: "cs", name: "Czech", flag: "🇨🇿" },
  { id: "fil", name: "Filipino", flag: "🇵🇭" },
  { id: "pl", name: "Polish", flag: "🇵🇱" },
  { id: "ro", name: "Romanian", flag: "🇷🇴" },
  { id: "sk", name: "Slovak", flag: "🇸🇰" },
  { id: "sv", name: "Swedish", flag: "🇸🇪" },
]
